export const META_ADS_MANAGER_FALLBACK_URL
  = "https://www.facebook.com/adsmanager/manage/campaigns"
export const META_LEADS_ACCESS_SETTINGS_URL
  = "https://business.facebook.com/settings/leads-accesses"

export function buildMetaAdsManagerUrl({
  adAccountId,
  businessId,
}: {
  adAccountId: string | null
  businessId: string | null
}): string {
  if (!adAccountId) return META_ADS_MANAGER_FALLBACK_URL

  const url = new URL("https://adsmanager.facebook.com/adsmanager/manage/ads")
  if (businessId) {
    url.searchParams.set("global_scope_id", businessId)
    url.searchParams.set("business_id", businessId)
  }
  url.searchParams.set("act", adAccountId)
  return url.toString()
}

export function buildMetaLeadsAccessSettingsUrl(businessId: string | null): string {
  if (!businessId) return META_LEADS_ACCESS_SETTINGS_URL
  const url = new URL(META_LEADS_ACCESS_SETTINGS_URL)
  url.searchParams.set("business_id", businessId)
  return url.toString()
}
